// Central site config for WxFaous.
// EDIT-ME-FIRST: the values in this file are what the tim WxFaous will change
// most often. Keep it flat and JSON-friendly so it can be swapped for a
// Google Sheets / AppSheet feed later without redesigning the site.

export const brand = {
    name: "WxFaous",
    legal: "PT Wxfaous Adijaya Sentosa",
    tagline: "",
    email: "wxfaous@gmail.com",
    phone: "+62 813-3007-979",
    phoneRaw: "628133007979",
    logoUrl:
        "https://customer-assets-wrfwihn1.emergentagent.net/job_live-shopping-id/artifacts/vyyasrgx_W%281%29.png",
    heroImage:
        "https://images.pexels.com/photos/1148957/pexels-photo-1148957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1000",
    address: {
        line1: "Spazio Tower Office Building Lantai 2 Unit 201",
    line2: "Jalan Mayjend. Jonosewojo Nomor Kavling 3, RT. 000 RW. 000, Pradah Kalikendal, Dukuh Pakis",
    city: "Kota Surabaya",
    province: "Jawa Timur",
    postal: "60225",
    country: "Indonesia",
    },
};

// ─────────────────────────────────────────────────────────────
// CURRENT PO / LIVE SHOPPING — change these three fields to
// update the banner on the homepage. Nothing else needs to move.
// ─────────────────────────────────────────────────────────────
export const currentPO = {
    active: true, // set to false to hide the pulsing red dot
    countryFlag: "🇨🇳",
    destination: "Guangzhou, China",
    dates: "21 September – 4 Oktober 2026",
};

// ─────────────────────────────────────────────────────────────
// EASY-TO-EDIT LINKS — the WhatsApp group link changes often
// (groups get full). Change `whatsappGroup` here to update the
// whole site.
// ─────────────────────────────────────────────────────────────
export const socialLinks = {
    whatsappOrder: "https://wa.me/628133007979",
    whatsappGroup: "https://chat.whatsapp.com/FHOs7CHY4GfGQPmMqFJJW2",
    whatsappChannel: "https://whatsapp.com/channel/0029VbCyQU790x32PproZP2k",
    instagram: "https://www.instagram.com/wxfaous",
    whatsappComplaint: "https://wa.me/62812327979",
};

// Five main landing-page buttons, rendered vertically link-in-bio style.
export const mainButtons = [
    {
        id: "wa-order",
        label: "Order WhatsApp",
        icon: "whatsapp",
        get url() {
            return socialLinks.whatsappOrder;
        },
    },
    {
        id: "wa-group",
        label: "Group Katalog WhatsApp",
        icon: "whatsapp",
        get url() {
            return socialLinks.whatsappGroup;
        },
    },
    {
        id: "wa-channel",
        label: "Channel WhatsApp",
        icon: "whatsapp",
        get url() {
            return socialLinks.whatsappChannel;
        },
    },
    {
        id: "instagram",
        label: "Instagram",
        icon: "instagram",
        get url() {
            return socialLinks.instagram;
        },
    },
    {
        id: "wa-complaint",
        label: "Komplain",
        icon: "whatsapp",
        get url() {
            return socialLinks.whatsappComplaint;
        },
    },
];

export const steps = [
    {
        n: "01",
        title: "DP & Mulai Order",
        desc: "DP awal Rp200.XXX. Isi XXX dengan 3 angka terakhir nomor WhatsApp; contoh 08123456789 → Rp200.789.",
    },
    {
        n: "02",
        title: "Pilih & Order Barang",
        desc: "Order saat Live Instagram, atau screenshot barang dari Instagram Story / WhatsApp Group lalu kirim ke Admin WhatsApp.",
    },
    {
        n: "03",
        title: "Pantau Status Pesanan",
        desc: "Cek status pesanan melalui website: DAPAT, BELUM DAPAT, atau SOLD OUT.",
    },
    {
        n: "04",
        title: "Pelunasan Barang DAPAT",
        desc: "Jika total barang yang sudah DAPAT melebihi saldo DP, lunasi kekurangannya sebelum melanjutkan belanja berikutnya.",
    },
    {
        n: "05",
        title: "Pelunasan Akhir & Pengiriman",
        desc: "Tagihan final dapat dicek di website setelah close PO. Lunasi sejak tagihan final diinfokan: China 30 hari, Bangkok 14 hari. Pengiriman bertahap mengikuti pelunasan dan jadwal PO.",
    },
];

// Dummy order used for /order/:token preview.
// In production this will be fetched from Google Sheets/AppSheet keyed by
// the secure random token in the URL. The token stays the same throughout
// one PO period even if items are added over time.
export const sampleOrder = {
    token: "sample",
    customerName: "Ibu Kirana",
    whatsapp: "0812-3456-7890",
    orderDate: "16 Februari 2026",
    destination: "Guangzhou, China",
    poWindow: "21 Sep – 4 Okt 2026",
    paymentStatus: "DP Lunas",
    items: [
        {
            id: "it-01",
            name: "Oversize Jacket Washed",
            variant: "Washed Blue · Size M",
            qty: 1,
            price: "Rp 685.000",
            status: "DAPAT",
            note: "Toko Baiyun · restock terbaru",
            image: "https://images.pexels.com/photos/1082529/pexels-photo-1082529.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
        },
        {
            id: "it-02",
            name: "High-Waist Straight Jeans",
            variant: "Light Wash · Size 27",
            qty: 2,
            price: "Rp 320.000",
            status: "DAPAT",
            note: "Baiyun New City · dua pcs",
            image: "https://images.pexels.com/photos/1598505/pexels-photo-1598505.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
        },
        {
            id: "it-03",
            name: "Cropped Button-Up Shirt",
            variant: "Indigo · Size S",
            qty: 1,
            price: "Rp 275.000",
            status: "BELUM_DAPAT",
            note: "Diantri di toko Shisanhang",
            image: "https://images.pexels.com/photos/6567607/pexels-photo-6567607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
        },
        {
            id: "it-04",
            name: "Wide-Leg Cargo Pants",
            variant: "Beige · Size M",
            qty: 1,
            price: "Rp 390.000",
            status: "SOLD_OUT",
            note: "Habis di 3 toko, menunggu restock",
            image: "https://images.pexels.com/photos/135620/pexels-photo-135620.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
        },
        {
            id: "it-05",
            name: "Canvas Tote Bag",
            variant: "Natural · One Size",
            qty: 3,
            price: "Rp 95.000",
            status: "DAPAT",
            note: "Nanhai · sudah packing",
            image: "https://images.pexels.com/photos/18046813/pexels-photo-18046813.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
        },
        {
            id: "it-06",
            name: "Chunky Sneakers White",
            variant: "White · Size 38",
            qty: 1,
            price: "Rp 425.000",
            status: "BELUM_DAPAT",
            note: "Cek ulang besok pagi",
            image: "https://images.pexels.com/photos/1464625/pexels-photo-1464625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
        },
    ],
};

export const statusMeta = {
    DAPAT: {
        label: "DAPAT",
        classes: "bg-emerald-50 text-emerald-700 border-emerald-200",
    },
    BELUM_DAPAT: {
        label: "BELUM DAPAT",
        classes: "bg-amber-50 text-amber-700 border-amber-200",
    },
    SOLD_OUT: {
        label: "SOLD OUT",
        classes: "bg-rose-50 text-rose-700 border-rose-200",
    },
};
